module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    staticClass: "info-box-icon bg-aqua"
  }, [_c('i', {
    staticClass: "ion ion-ios-gear-outline"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("CPU Traffic")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("90"), _c('small', [_vm._v("%")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Likes")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("41,410")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-ios-cart-outline"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Sales")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("760")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-ios-people-outline"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("New Members")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("2,000")])])])])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Monthly Recap Report")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-box-tool dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Sales: 1 Jan, 2014 - 30 Jul, 2014")])]), _vm._v(" "), _c('div', {
    staticClass: "chart"
  }, [_c('canvas', {
    staticStyle: {
      "height": "180px"
    },
    attrs: {
      "id": "salesChart"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Goal Completion")])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group"
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Add Products to Cart")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v("160")]), _vm._v("/200")]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "80%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group"
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Complete Purchase")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v("310")]), _vm._v("/400")]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-red",
    staticStyle: {
      "width": "80%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group"
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Visit Premium Page")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v("480")]), _vm._v("/800")]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "80%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group"
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Send Inquiries")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v("250")]), _vm._v("/500")]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-yellow",
    staticStyle: {
      "width": "80%"
    }
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('row', [_c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('div', {
    staticClass: "description-block border-right"
  }, [_c('span', {
    staticClass: "description-percentage text-green"
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  }), _vm._v(" 17%")]), _vm._v(" "), _c('h5', {
    staticClass: "description-header"
  }, [_vm._v("$35,210.43")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("TOTAL REVENUE")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('div', {
    staticClass: "description-block border-right"
  }, [_c('span', {
    staticClass: "description-percentage text-yellow"
  }, [_c('i', {
    staticClass: "fa fa-caret-left"
  }), _vm._v(" 0%")]), _vm._v(" "), _c('h5', {
    staticClass: "description-header"
  }, [_vm._v("$10,390.90")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("TOTAL COST")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('div', {
    staticClass: "description-block border-right"
  }, [_c('span', {
    staticClass: "description-percentage text-green"
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  }), _vm._v(" 20%")]), _vm._v(" "), _c('h5', {
    staticClass: "description-header"
  }, [_vm._v("$24,813.53")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("TOTAL PROFIT")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-6"
  }, [_c('div', {
    staticClass: "description-block"
  }, [_c('span', {
    staticClass: "description-percentage text-red"
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  }), _vm._v(" 18%")]), _vm._v(" "), _c('h5', {
    staticClass: "description-header"
  }, [_vm._v("1200")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("GOAL COMPLETIONS")])])])])], 1)])])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Visitors Report")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-9 col-sm-8"
  }, [_c('div', {
    staticClass: "pad"
  }, [_c('div', {
    staticStyle: {
      "height": "325px"
    },
    attrs: {
      "id": "world-map-markers"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-4"
  }, [_c('div', {
    staticClass: "pad box-pane-right bg-green",
    staticStyle: {
      "min-height": "280px"
    }
  }, [_c('div', {
    staticClass: "description-block margin-bottom"
  }, [_c('div', {
    staticClass: "sparkbar pad",
    attrs: {
      "data-color": "#fff"
    }
  }, [_vm._v("90,70,90,70,75,80,70")]), _vm._v(" "), _c('h5', {
    staticClass: "description-header"
  }, [_vm._v("8390")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("Visits")])]), _vm._v(" "), _c('div', {
    staticClass: "description-block margin-bottom"
  }, [_c('div', {
    staticClass: "sparkbar pad",
    attrs: {
      "data-color": "#fff"
    }
  }, [_vm._v("90,50,90,70,61,83,63")]), _vm._v(" "), _c('h5', {
    staticClass: "description-header"
  }, [_vm._v("30%")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("Referrals")])]), _vm._v(" "), _c('div', {
    staticClass: "description-block"
  }, [_c('div', {
    staticClass: "sparkbar pad",
    attrs: {
      "data-color": "#fff"
    }
  }, [_vm._v("90,50,90,70,61,83,63")]), _vm._v(" "), _c('h5', {
    staticClass: "description-header"
  }, [_vm._v("70%")]), _vm._v(" "), _c('span', {
    staticClass: "description-text"
  }, [_vm._v("Organic")])])])])])], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-warning direct-chat direct-chat-warning"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Direct Chat")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('span', {
    staticClass: "badge bg-yellow",
    attrs: {
      "data-toggle": "tooltip",
      "title": "3 New Messages"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Contacts",
      "data-widget": "chat-pane-toggle"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "direct-chat-messages"
  }, [_c('div', {
    staticClass: "direct-chat-msg"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-left"
  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-right"
  }, [_vm._v("23 Jan 2:00 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": require("admin-lte/dist/img/user1-128x128.jpg"),
      "alt": "message user image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                    Is this template really for free? That's unbelievable!\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-msg right"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-right"
  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-left"
  }, [_vm._v("23 Jan 2:05 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": require("admin-lte/dist/img/user3-128x128.jpg"),
      "alt": "message user image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                    You better believe it!\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-msg"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-left"
  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-right"
  }, [_vm._v("23 Jan 5:37 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": require("admin-lte/dist/img/user1-128x128.jpg"),
      "alt": "message user image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                    Working with AdminLTE on a great new app! Wanna join?\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-msg right"
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name pull-right"
  }, [_vm._v("Sarah Bullock")]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-left"
  }, [_vm._v("23 Jan 6:10 pm")])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": require("admin-lte/dist/img/user3-128x128.jpg"),
      "alt": "message user image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n                    I would love to.\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-contacts"
  }, [_c('ul', {
    staticClass: "contacts-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "contacts-list-img",
    attrs: {
      "src": require("admin-lte/dist/img/user1-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-list-info"
  }, [_c('span', {
    staticClass: "contacts-list-name"
  }, [_vm._v("\n                              Count Dracula\n                              "), _c('small', {
    staticClass: "contacts-list-date pull-right"
  }, [_vm._v("2/28/2015")])]), _vm._v(" "), _c('span', {
    staticClass: "contacts-list-msg"
  }, [_vm._v("How have you been? I was...")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "contacts-list-img",
    attrs: {
      "src": require("admin-lte/dist/img/user7-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-list-info"
  }, [_c('span', {
    staticClass: "contacts-list-name"
  }, [_vm._v("\n                              Sarah Doe\n                              "), _c('small', {
    staticClass: "contacts-list-date pull-right"
  }, [_vm._v("2/23/2015")])]), _vm._v(" "), _c('span', {
    staticClass: "contacts-list-msg"
  }, [_vm._v("I will be waiting for...")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "contacts-list-img",
    attrs: {
      "src": require("admin-lte/dist/img/user3-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-list-info"
  }, [_c('span', {
    staticClass: "contacts-list-name"
  }, [_vm._v("\n                              Nadia Jolie\n                              "), _c('small', {
    staticClass: "contacts-list-date pull-right"
  }, [_vm._v("2/20/2015")])]), _vm._v(" "), _c('span', {
    staticClass: "contacts-list-msg"
  }, [_vm._v("I'll call you back at...")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "contacts-list-img",
    attrs: {
      "src": require("admin-lte/dist/img/user5-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-list-info"
  }, [_c('span', {
    staticClass: "contacts-list-name"
  }, [_vm._v("\n                              Nora S. Vans\n                              "), _c('small', {
    staticClass: "contacts-list-date pull-right"
  }, [_vm._v("2/10/2015")])]), _vm._v(" "), _c('span', {
    staticClass: "contacts-list-msg"
  }, [_vm._v("Where is your new...")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "contacts-list-img",
    attrs: {
      "src": require("admin-lte/dist/img/user6-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-list-info"
  }, [_c('span', {
    staticClass: "contacts-list-name"
  }, [_vm._v("\n                              John K.\n                              "), _c('small', {
    staticClass: "contacts-list-date pull-right"
  }, [_vm._v("1/27/2015")])]), _vm._v(" "), _c('span', {
    staticClass: "contacts-list-msg"
  }, [_vm._v("Can I take a look at...")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "contacts-list-img",
    attrs: {
      "src": require("admin-lte/dist/img/user8-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts-list-info"
  }, [_c('span', {
    staticClass: "contacts-list-name"
  }, [_vm._v("\n                              Kenneth M.\n                              "), _c('small', {
    staticClass: "contacts-list-date pull-right"
  }, [_vm._v("1/4/2015")])]), _vm._v(" "), _c('span', {
    staticClass: "contacts-list-msg"
  }, [_vm._v("Never mind I found...")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "message",
      "placeholder": "Type Message ..."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Send")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-danger"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Latest Members")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("8 New Members")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding"
  }, [_c('ul', {
    staticClass: "users-list clearfix"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user1-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Alexander Pierce")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("Today")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user8-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Norman")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("Yesterday")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user7-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Jane")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("12 Jan")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user6-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("John")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("12 Jan")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user2-160x160.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Alexander")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("13 Jan")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user5-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sarah")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("14 Jan")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user4-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nora")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("15 Jan")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/user3-128x128.jpg"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "users-list-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nadia")]), _vm._v(" "), _c('span', {
    staticClass: "users-list-date"
  }, [_vm._v("15 Jan")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('a', {
    staticClass: "uppercase",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("View All Users")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Latest Orders")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table no-margin"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Order ID")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Popularity")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "pages/examples/invoice.html"
    }
  }, [_vm._v("OR9842")])]), _vm._v(" "), _c('td', [_vm._v("Call of Duty IV")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Shipped")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "sparkbar",
    attrs: {
      "data-color": "#00a65a",
      "data-height": "20"
    }
  }, [_vm._v("90,80,90,-70,61,-83,63")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "pages/examples/invoice.html"
    }
  }, [_vm._v("OR1848")])]), _vm._v(" "), _c('td', [_vm._v("Samsung Smart TV")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Pending")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "sparkbar",
    attrs: {
      "data-color": "#f39c12",
      "data-height": "20"
    }
  }, [_vm._v("90,80,-90,70,61,-83,68")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "pages/examples/invoice.html"
    }
  }, [_vm._v("OR7429")])]), _vm._v(" "), _c('td', [_vm._v("iPhone 6 Plus")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Delivered")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "sparkbar",
    attrs: {
      "data-color": "#f56954",
      "data-height": "20"
    }
  }, [_vm._v("90,-80,90,70,-61,83,63")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "pages/examples/invoice.html"
    }
  }, [_vm._v("OR7429")])]), _vm._v(" "), _c('td', [_vm._v("Samsung Smart TV")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Processing")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "sparkbar",
    attrs: {
      "data-color": "#00c0ef",
      "data-height": "20"
    }
  }, [_vm._v("90,80,-90,70,-61,83,63")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "pages/examples/invoice.html"
    }
  }, [_vm._v("OR1848")])]), _vm._v(" "), _c('td', [_vm._v("Samsung Smart TV")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Pending")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "sparkbar",
    attrs: {
      "data-color": "#f39c12",
      "data-height": "20"
    }
  }, [_vm._v("90,80,-90,70,61,-83,68")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "pages/examples/invoice.html"
    }
  }, [_vm._v("OR7429")])]), _vm._v(" "), _c('td', [_vm._v("iPhone 6 Plus")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Delivered")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "sparkbar",
    attrs: {
      "data-color": "#f56954",
      "data-height": "20"
    }
  }, [_vm._v("90,-80,90,70,-61,83,63")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": "pages/examples/invoice.html"
    }
  }, [_vm._v("OR9842")])]), _vm._v(" "), _c('td', [_vm._v("Call of Duty IV")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Shipped")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "sparkbar",
    attrs: {
      "data-color": "#00a65a",
      "data-height": "20"
    }
  }, [_vm._v("90,80,90,-70,61,-83,63")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-info btn-flat pull-left",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Place New Order")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-default btn-flat pull-right",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("View All Orders")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "info-box bg-yellow"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "ion ion-ios-pricetag-outline"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Inventory")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("5,200")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n                50% Increase in 30 Days\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "info-box bg-green"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "ion ion-ios-heart-outline"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Mentions")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("92,050")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n                20% Increase in 30 Days\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "info-box bg-red"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "ion ion-ios-cloud-download-outline"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Downloads")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("114,381")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "70%"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n                70% Increase in 30 Days\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "info-box bg-aqua"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "ion-ios-chatbubble-outline"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Direct Messages")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v("163,921")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "40%"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n                40% Increase in 30 Days\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Browser Usage")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "chart-responsive"
  }, [_c('canvas', {
    attrs: {
      "id": "pieChart",
      "height": "150"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('ul', {
    staticClass: "chart-legend clearfix"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-circle-o text-red"
  }), _vm._v(" Chrome")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-circle-o text-green"
  }), _vm._v(" IE")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-circle-o text-yellow"
  }), _vm._v(" FireFox")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-circle-o text-aqua"
  }), _vm._v(" Safari")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-circle-o text-light-blue"
  }), _vm._v(" Opera")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-circle-o text-gray"
  }), _vm._v(" Navigator")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-stacked"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("United States of America\n              "), _c('span', {
    staticClass: "pull-right text-red"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  }), _vm._v(" 12%")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("India "), _c('span', {
    staticClass: "pull-right text-green"
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  }), _vm._v(" 4%")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("China\n              "), _c('span', {
    staticClass: "pull-right text-yellow"
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" 0%")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Recently Added Products")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "products-list product-list-in-box"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/default-50x50.gif"),
      "alt": "Product Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [_c('a', {
    staticClass: "product-title",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Samsung TV\n                  "), _c('span', {
    staticClass: "label label-warning pull-right"
  }, [_vm._v("$1800")])]), _vm._v(" "), _c('span', {
    staticClass: "product-description"
  }, [_vm._v("\n                      Samsung 32\" 1080p 60Hz LED Smart HDTV.\n                    ")])])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/default-50x50.gif"),
      "alt": "Product Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [_c('a', {
    staticClass: "product-title",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Bicycle\n                  "), _c('span', {
    staticClass: "label label-info pull-right"
  }, [_vm._v("$700")])]), _vm._v(" "), _c('span', {
    staticClass: "product-description"
  }, [_vm._v("\n                      26\" Mongoose Dolomite Men's 7-speed, Navy Blue.\n                    ")])])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/default-50x50.gif"),
      "alt": "Product Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [_c('a', {
    staticClass: "product-title",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Xbox One "), _c('span', {
    staticClass: "label label-danger pull-right"
  }, [_vm._v("$350")])]), _vm._v(" "), _c('span', {
    staticClass: "product-description"
  }, [_vm._v("\n                      Xbox One Console Bundle with Halo Master Chief Collection.\n                    ")])])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": require("admin-lte/dist/img/default-50x50.gif"),
      "alt": "Product Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [_c('a', {
    staticClass: "product-title",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("PlayStation 4\n                  "), _c('span', {
    staticClass: "label label-success pull-right"
  }, [_vm._v("$399")])]), _vm._v(" "), _c('span', {
    staticClass: "product-description"
  }, [_vm._v("\n                      PlayStation 4 500GB Console (PS4)\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('a', {
    staticClass: "uppercase",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("View All Products")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39f80db9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sample.vue
// module id = 748
// module chunks = 0